var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 0H3.00004C2.20438 0 1.44131 0.316075 0.878692 0.878692C0.316075 1.44131 0 2.20438 0 3.00004L0 12.0002C0 12.7958 0.316075 13.5589 0.878692 14.1215C1.44131 14.6841 2.20438 15.0002 3.00004 15.0002H5.17507L8.51337 17.8225C8.6488 17.9371 8.82046 18 8.99788 18C9.17529 18 9.34696 17.9371 9.48238 17.8225L12.8252 15.0002H15.0002C15.7959 15.0002 16.5589 14.6841 17.1216 14.1215C17.6842 13.5589 18.0003 12.7958 18.0003 12.0002V3.00004C18.0003 2.20438 17.6842 1.44131 17.1216 0.878692C16.5589 0.316075 15.7959 0 15.0002 0V0ZM16.5002 12.0002C16.5002 12.398 16.3422 12.7795 16.0609 13.0608C15.7796 13.3422 15.398 13.5002 15.0002 13.5002H12.8252C12.4706 13.5003 12.1276 13.626 11.8569 13.8549L9.00013 16.2677L6.14484 13.8549C5.87375 13.6256 5.53013 13.4999 5.17507 13.5002H3.00004C2.60221 13.5002 2.22068 13.3422 1.93937 13.0608C1.65806 12.7795 1.50002 12.398 1.50002 12.0002V3.00004C1.50002 2.60221 1.65806 2.22068 1.93937 1.93937C2.22068 1.65806 2.60221 1.50002 3.00004 1.50002H15.0002C15.398 1.50002 15.7796 1.65806 16.0609 1.93937C16.3422 2.22068 16.5002 2.60221 16.5002 3.00004V12.0002Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduce);
export default __webpack_public_path__ + "static/media/introduce.7f284f72877b946d1f1a0e6f9305556f.svg";
export { ForwardRef as ReactComponent };